(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * ログ送信
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param messageID メッセージID
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.sendLog = sendLog;
exports.initClickLog = initClickLog;

function sendLog(target, messageID) {
  if (!s) return;
  s.tl(target, 'o', messageID);
}

/**
 * @description クリックログ送信
 * @param clickLogElementList イベント観測対象
 * @param dataName - 飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
 */

function initClickLog(clickLogElementList, dataName) {
  var clickLogTriggerElements = Array.prototype.slice.call(clickLogElementList, 0);
  clickLogTriggerElements.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var clickedElement = event.currentTarget;
      var customLink = clickedElement.dataset[dataName];
      sendLog(clickedElement, customLink);
      event.stopPropagation();
    });
  });
}

},{}],2:[function(require,module,exports){
/**
* ログ送信
* @param s 基本的に進路内にグローバルに存在する『s』をいれる
* @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
* @param customLink カスタムリンク
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.initScrollLog = initScrollLog;
function sendLog(s, target, customLink) {
  if (!s) return;
  s.tl(target, 'o', customLink);
}

/**
* スクロールログinit
* @param s 基本的に進路内にグローバルに存在する『s』をいれる
* @param scrollLogTargetList イベント観測対象
* @param dataNameInView - 表示領域inで飛ばしたいログ設定用のデータ属性名（data-xxxxの部分のキャメルケースのみ）
* @returns 処理後のターゲットリスト
*/

function initScrollLog(s, scrollLogTargetList, dataNameInView) {

  // オプション設定
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: 1
  };
  // 要素が画面に入ったときの処理
  var inViewCallback = function inViewCallback(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var customLink = entry.target.dataset[dataNameInView];
      sendLog(s, entry.target, customLink);
      // 一度inViewログを飛ばしたら、監視をやめる
      observer.unobserve(entry.target);
    });
  };

  // IntersectionObserverを呼ぶ
  var observer = new IntersectionObserver(inViewCallback, options);
  scrollLogTargetList.forEach(function (target) {
    observer.observe(target);
  });
}

},{}],3:[function(require,module,exports){
'use strict';

var _this = this;

var _componentSp_s_SlistfallCampaignBanner = require('../component/sp/_s_SlistfallCampaignBanner');

var _componentSp_s_mypageModal = require('../component/sp/_s_mypageModal');

window.addEventListener('DOMContentLoaded', function () {
  (0, _componentSp_s_SlistfallCampaignBanner.initCampaignBannerModal)('H');
});

// マイページ
window.addEventListener('load', function () {
  // レスポンシブ対応_PC画面にマイペ機能が無いため、UA判断してPCには表示させない
  var handleClientHints = function handleClientHints(uaClientHints) {
    var platformData, mobileData;
    return regeneratorRuntime.async(function handleClientHints$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          context$2$0.prev = 0;
          context$2$0.next = 3;
          return regeneratorRuntime.awrap(uaClientHints.getHighEntropyValues(["platform"]));

        case 3:
          platformData = context$2$0.sent;

          if (!platformData.platform) {
            context$2$0.next = 11;
            break;
          }

          context$2$0.next = 7;
          return regeneratorRuntime.awrap(uaClientHints.getHighEntropyValues(["mobile"]));

        case 7:
          mobileData = context$2$0.sent;

          loadMyPageModal(mobileData.mobile);
          context$2$0.next = 12;
          break;

        case 11:
          fallbackToUserAgent();

        case 12:
          context$2$0.next = 17;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](0);

          fallbackToUserAgent();

        case 17:
        case 'end':
          return context$2$0.stop();
      }
    }, null, _this, [[0, 14]]);
  };

  // User-Agent Client Hintsが利用できないブラウザは従来通り、navigator.userAgentで判定
  var fallbackToUserAgent = function fallbackToUserAgent() {
    var ua = navigator.userAgent || '';
    var isMobile = /iPhone|iPad|Android|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    loadMyPageModal(isMobile);
  };

  var loadMyPageModal = function loadMyPageModal(isMobile) {
    if (isMobile) {
      // SPの場合のみ表示
      OpenMyPageModal();
    }
  };

  var OpenMyPageModal = function OpenMyPageModal() {
    var getSssLocalStorage = localStorage.getItem('sss');
    var parsedSss = JSON.parse(getSssLocalStorage);
    var attributeModalAbPattern = parsedSss['fe-1950-attributeModalAbPattern'];
    var attributeModalOpened = parsedSss['attributeModalOpened'];

    // 属性アンケートがAパターンもしくはBパターンで既に表示済みのとき
    if (attributeModalAbPattern === 'A' || attributeModalAbPattern === 'B' && attributeModalOpened) {
      (0, _componentSp_s_mypageModal.mypageModal)();
    }
  };

  // User-Agent Client Hintsが利用できる場合（Chrome対策）
  var uaClientHints = navigator.userAgentData;
  if (uaClientHints) {
    handleClientHints(uaClientHints);
  } else {
    fallbackToUserAgent();
  }
});

// iosのChromeではなぜかnavigator.userAgentDataが正しく取得できないが、"mobile"だけfalseが返却されてしまう
// "platform"はnavigator.userAgentDataが取得できた場合には必ず値が入るため、"platform"の条件分岐を追加した

},{"../component/sp/_s_SlistfallCampaignBanner":5,"../component/sp/_s_mypageModal":6}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var s2 = typeof s_gi === 'function' && s_account ? s_gi(s_account) : null;

var prop4 = s2 ? s2.prop4 : null;

exports.prop4 = prop4;
var SendCustomLinkLog = function SendCustomLinkLog(target, logId) {
  if (!s2) {
    return;
  }
  s2.tl(target, 'o', logId);
};

exports.SendCustomLinkLog = SendCustomLinkLog;
var SendAbTestLog = function SendAbTestLog(prop25) {
  if (!s2) {
    return;
  }
  // バックアップ
  var ltvbk = s2.linkTrackVars;
  var p25bk = s2.prop25;
  // 一時的に上書き
  s2.linkTrackVars = 'prop25';
  s2.prop25 = prop25;
  // 送信処理
  s2.tl(window, 'o', s2.prop25);
  // リストア
  s2.linkTrackVars = ltvbk;
  s2.prop25 = p25bk;
};
exports.SendAbTestLog = SendAbTestLog;

},{}],5:[function(require,module,exports){
// front-SHINGAKU-3940 マーケG 検索一覧_CPバナー追加

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _jsAssetsComponent_sendClickLog = require('../../../../../js/assets/component/_sendClickLog');

var _jsAssetsComponent_sendScrollLog = require('../../../../../js/assets/component/_sendScrollLog');

/**
 * CP情報を表示するJSONデータを取得
 */
function getCampaignJson() {
  var response, campaign_json;
  return regeneratorRuntime.async(function getCampaignJson$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.prev = 0;
        context$1$0.next = 3;
        return regeneratorRuntime.awrap(fetch('/rnet/js/campaign_param.json'));

      case 3:
        response = context$1$0.sent;

        if (response.ok) {
          context$1$0.next = 6;
          break;
        }

        throw new Error('');

      case 6:
        context$1$0.next = 8;
        return regeneratorRuntime.awrap(response.json());

      case 8:
        campaign_json = context$1$0.sent;

        // 金額表示が4桁以上の場合、カンマを付与する
        campaign_json.rewardAmount = campaign_json.rewardAmount >= 1000 ? campaign_json.rewardAmount.toLocaleString('en-US') : campaign_json.rewardAmount.toString();
        return context$1$0.abrupt('return', campaign_json);

      case 13:
        context$1$0.prev = 13;
        context$1$0.t0 = context$1$0['catch'](0);
        return context$1$0.abrupt('return', {
          campaign: false
        });

      case 16:
      case 'end':
        return context$1$0.stop();
    }
  }, null, this, [[0, 13]]);
}

/**
 * カートに追加された学校を取得
 */
function getCartClispList() {
  var response, cartData;
  return regeneratorRuntime.async(function getCartClispList$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.prev = 0;
        context$1$0.next = 3;
        return regeneratorRuntime.awrap(fetch('/smp2/cart/clipList'));

      case 3:
        response = context$1$0.sent;

        if (response.ok) {
          context$1$0.next = 6;
          break;
        }

        throw new Error('');

      case 6:
        context$1$0.next = 8;
        return regeneratorRuntime.awrap(response.json());

      case 8:
        cartData = context$1$0.sent;
        return context$1$0.abrupt('return', cartData);

      case 12:
        context$1$0.prev = 12;
        context$1$0.t0 = context$1$0['catch'](0);
        return context$1$0.abrupt('return', {
          data: ''
        });

      case 15:
      case 'end':
        return context$1$0.stop();
    }
  }, null, this, [[0, 12]]);
}

/**
 * 各キャンペーンコンポーネントのHTMLコンテンツを生成するための関数群
 */
var htmlGenerators = {
  /**
   * Hパターンで使用
   * 帯型のキャンペーンHTMLを生成
   */
  obiCp: function obiCp(campaign_json) {
    return '\n    <section class="include-campaignObiBanner js-include-campaignObiBanner">\n      <p class="include-campaignObiTitle">\n        高校生限定！<span class="include-campaignObiNum">' + campaign_json.campaignNum + '</span>校以上請求で<span class="include-campaignObiReward">' + campaign_json.reward + '\n          <span class="include-campaignObiAmount">' + campaign_json.rewardAmount + '</span>円分</span>プレゼント！\n      </p>\n    </section>\n    ';
  },

  /**
   * Hパターンで使用
   * 資料請求バナーのHTMLを生成
   */
  shiryouSeikyuHeaderBanner: function shiryouSeikyuHeaderBanner() {
    return '\n    <div class="include-headGridContainer js-include-headGridContainer">\n      <div class="include-closeIcon js-includeBannerClose js-includeClickLog" data-click-log="cpbanner_close_SlistfAll">\n      </div>\n        <div class="include-openModalAriaWrapper js-includeModalOpen js-includeClickLog" data-click-log="cpbanner_click_SlistfAll">\n          <div class="include-textSection">\n            <div class="include-textLine">\n              まずは気になる学校を\n            </div>\n            <div class="include-textLine">\n              <span class="include-obiMoreEmphasizedText include-obiMoreEmphasizedText--sp">資料請求カートに追加</span><span class="include-obiMoreEmphasizedText include-obiMoreEmphasizedText--pc">リストに追加</span><span class="include-emphasizedText">しよう！</span>\n            </div>\n          </div>\n          <div class="include-imageItem">\n            <img src="/rnet/include/s/commonPage/Slist_f_All/addShiryoSeikyuCart_H.png" class="include-imageItem-sp" alt="資料請求カートに追加しよう" style="width:112px">\n            <img src="/rnet/include/s/commonPage/Slist_f_All/addShiryoSeikyuCart_pc.png" class="include-imageItem-pc" alt="リストに追加しよう" style="width:101px">\n          </div>\n          <div class="include-arrowIcon"></div>\n        </div>\n    </div>\n  ';
  },

  /**
   * 資料請求バナーとCP情報両方を組み合わせたHTMLを生成するラッパー関数
   */
  wrapperBanner: function wrapperBanner(shiryouSeikyuBannerHTML, bannarCpHTML) {
    return '\n      <section class="include-Wrapper js-include-Wrapper js-includeViewLog js-includeToggleDisplay" data-inview-log="cpbanner_imp_SlistfAll">\n        <div class="include-contents">\n          ' + (bannarCpHTML || '') + '\n          ' + shiryouSeikyuBannerHTML + '\n        </div>\n      </section>\n    ';
  },

  /**
   * キャンペーンモーダルのHTMLを生成
   */
  cpModal: function cpModal(campaign_json) {
    return '\n    <section class="include-CpModal js-includeCpModal js-includeClickLog" data-click-log="cpbanner_modal_close_SlistfAll">\n      <div class="include-CpModal__wrapper js-includeCpModalWrapper">\n        <div class="include-CpModal__closeButton include-CpModal__closeButton--pc js-includeCpModalClose js-includeClickLog" data-click-log="cpbanner_modal_close_SlistfAll">\n          <img src="/rnet/include/s/commonPage/Slist_f_All/close_button_white.svg" alt="閉じる" class="include-CpModal__closeButtonImage">\n        </div>\n        <div class="include-CpModal__content">\n          <div class="include-CpModal__heading">\n            <p class="include-CpModal__headingText">\n              無料パンフ・願書<span class="include-CpModal__headingCampaignNum">' + campaign_json.campaignNum + '</span>校以上資料請求で\n            </p>\n            <p class="include-CpModal__headingEmphasizedText">\n              ' + campaign_json.reward + ' <span class="include-CpModal__rewardAmount">' + campaign_json.rewardAmount + '</span>円分プレゼント！\n            </p>\n            <div class="include-CpModal__headingImg">\n              <img src="/rnet/include/s/commonPage/Slist_f_All/bookCard.png" alt="図書カード" class="include-CpModal__bookCardImg include-CpModal__bookCardImg--sp" style="width:200px">\n              <img src="/rnet/include/s/commonPage/Slist_f_All/bookCard_PC.png" alt="図書カード" class="include-CpModal__bookCardImg include-CpModal__bookCardImg--pc" style="width:322px">\n            </div>\n          </div>\n          <div class="include-CpModal__body">\n            <p class="include-CpModal__description">＼カンタン3ステップでゲット！／</p>\n            <div class="include-CpModal__step">\n              <div class="include-CpModal__stepItem">\n                <div class="include-CpModal__stepNumber">\n                  01\n                </div>\n                <div class="include-CpModal__stepText">\n                  気になる学校をカートに追加！\n                </div>\n                <img class="include-CpModal__stepImg include-CpModal__stepImg--sp" src="/rnet/include/s/commonPage/Slist_f_All/addShiryoSeikyuCart_Modal.png" alt="気になる学校をカートに追加！" style="width:100%">\n                <img class="include-CpModal__stepImg include-CpModal__stepImg--pc" src="/rnet/include/s/commonPage/Slist_f_All/addShiryoSeikyuCart_Modal_PC.png" alt="気になる学校をカートに追加！" style="width:100%">\n              </div>\n              <div class="include-CpModal__dots">\n                <span class="include-CpModal__dotsIcon"></span>\n                <span class="include-CpModal__dotsIcon"></span>\n                <span class="include-CpModal__dotsIcon"></span>\n              </div>\n              <div class="include-CpModal__stepItem">\n                <div class="include-CpModal__stepNumber">\n                  02\n                </div>\n                <div class="include-CpModal__stepText">\n                  まとめて資料請求をタップ！\n                </div>\n                <img class="include-CpModal__stepImg include-CpModal__stepImg--sp" src="/rnet/include/s/commonPage/Slist_f_All/matometeShiryoSeikyu.png" alt="まとめて資料請求をタップ！" style="width:100%">\n                <img class="include-CpModal__stepImg include-CpModal__stepImg--pc" src="/rnet/include/s/commonPage/Slist_f_All/matometeShiryoSeikyu_PC.png" alt="まとめて資料請求をタップ！" style="width:100%">\n              </div>\n              <div class="include-CpModal__dots">\n                <span class="include-CpModal__dotsIcon"></span>\n                <span class="include-CpModal__dotsIcon"></span>\n                <span class="include-CpModal__dotsIcon"></span>\n              </div>\n              <div class="include-CpModal__stepItem">\n                <div class="include-CpModal__stepNumber">\n                  03\n                </div>\n                <div class="include-CpModal__stepText">\n                  送付先を入力で完了！\n                </div>\n                <img class="include-CpModal__stepImg include-CpModal__stepImg--sp" src="/rnet/include/s/commonPage/Slist_f_All/bookCard_Modal.png" alt="送付先を入力で完了！" style="width:100%">\n                <img class="include-CpModal__stepImg include-CpModal__stepImg--pc" src="/rnet/include/s/commonPage/Slist_f_All/bookCard_Modal_PC.png" alt="送付先を入力で完了！" style="width:100%">\n              </div>\n            </div>\n            <div class="include-CpModal__detailLink">\n              <a class="include-CpModal__linkColor js-includeClickLog" data-click-log="cpbanner_modal_detail_SlistfAll" href="/rnet/s/campaign/shiryou/s_allpre.html" target="_blank">詳細はこちら</a>\n            </div>\n          </div>\n        </div>\n        <div class="include-CpModal__closeButton include-CpModal__closeButton--sp js-includeCpModalClose js-includeClickLog" data-click-log="cpbanner_modal_close_SlistfAll">閉じる</div>\n      </div>\n    </section>\n  ';
  }
};

/**
 * 特定の要素のCSSスタイルを変更
 * @param {string} dom - 対象となる要素のdom
 * @param {string} property - 変更するCSSのプロパティ。
 * @param {string} value - CSSプロパティの新しい値。
 */
var modifyStyle = function modifyStyle(dom, property, value) {
  if (dom) {
    dom.style[property] = value;
  }
};

/**
 * 要素にイベントリスナを追加
 * @param {string} dom - 対象となる要素のdom。
 * @param {string} event - イベントの種類。
 * @param {Function} callback - イベントが発生したときに実行されるコールバック関数。
 */
var addEventListenerToElement = function addEventListenerToElement(dom, event, callback) {
  if (dom) {
    dom.addEventListener(event, callback);
  }
};

/**
 * HTMLを画面に追加する関数
 */
function appendHtmlToTarget(targetElement, bannerHtml, modalHtml) {
  if (targetElement) {
    targetElement.insertAdjacentHTML('beforebegin', bannerHtml);
    targetElement.insertAdjacentHTML('beforebegin', modalHtml);
  }
}

/**
 * Hパターンで使用
 * ヘッダーの高さを取得する関数
 */
var getHeaderHeight = function getHeaderHeight() {
  // ヘッダーの高さを代入
  var headerBannerHeight = 64;

  // 帯とバナーの高さを取得
  if (abPattern === 'H' && window.innerWidth >= 327 && window.innerWidth < 768) {
    // バナー内のテキストを取得
    var bannerText = document.querySelector('.js-include-campaignObiBanner').textContent;
    // 改行、タブ、スペースを取り除く
    bannerText = bannerText.replace(/[\r\n\s]+/g, '');
    // 32文字を超えると、2行表示になるので、ヘッダーの高さを再代入する
    if (bannerText.length >= 32) {
      headerBannerHeight = 77;
    }
  };
  return headerBannerHeight;
};

/**
 * Hパターンで使用
 * スクロールでバナーを表示する関数
 */
var displayBannerScroll = function displayBannerScroll() {
  var toggleElement = document.querySelector('.js-includeToggleDisplay');
  // 現在のスクロール位置を取得
  var currentScrollPosition = document.documentElement.scrollTop;

  // ヘッダーの高さを取得
  var headerBannerHeight = getHeaderHeight();

  // 一番上にスクロールされたら要素を非表示にする
  if (headerBannerHeight >= currentScrollPosition) {
    modifyStyle(toggleElement, 'display', 'none');
  }
  // 帯とバナーの高さ分スクロールされていれば要素を表示する
  else if (currentScrollPosition >= headerBannerHeight) {
      if (window.innerWidth < 768) {
        modifyStyle(toggleElement, 'display', 'block');
      } else {
        modifyStyle(toggleElement, 'display', 'flex');
      }
    }
};

/**
 * イベントリスナーを追加する関数群
 */
function addEventListeners() {

  // バナー内のモーダルをオープンするDOM
  var openModalElement = document.querySelector('.js-includeModalOpen');
  // モーダル内の「閉じる」ボタンのDOM
  var closeModalElements = document.querySelectorAll('.js-includeCpModalClose');
  // モーダルの外枠のDOM
  var closeFrameModalElement = document.querySelector('.js-includeCpModal');
  // モーダル本体のDOM
  var modalElement = document.querySelector('.js-includeCpModalWrapper');
  // 資料請求カートボタンのDOM
  var cartButtonElements = document.querySelectorAll('.js-cassetteCarts');
  // CPバナーのDOM
  var cpBannerElement = document.querySelector('.js-include-Wrapper');
  // CPバナーのバツボタンのDOM
  var cpBannerCloseElement = document.querySelector('.js-includeBannerClose');

  // バナー押下でモーダルを表示するイベント
  addEventListenerToElement(openModalElement, "click", function () {
    modifyStyle(closeFrameModalElement, 'display', 'flex');
  });

  // 「閉じる」押下でモーダルをクローズするイベント
  closeModalElements.forEach(function (closeModalElement) {
    addEventListenerToElement(closeModalElement, "click", function () {
      modifyStyle(closeFrameModalElement, 'display', 'none');
    });
  });

  // モーダルの外枠押下で、モーダルをクローズするイベント
  addEventListenerToElement(closeFrameModalElement, "click", function () {
    modifyStyle(closeFrameModalElement, 'display', 'none');
  });

  // モーダル本体押下でモーダルがクローズされるのを止めるイベント
  modalElement.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // 「資料請求カート」押下でバナーを削除するイベント
  cartButtonElements.forEach(function (cartButtonElement) {
    addEventListenerToElement(cartButtonElement, "click", function () {
      if (cpBannerElement) {
        // 要素の削除
        cpBannerElement.remove();
        // イベントリスナーの削除
        window.removeEventListener('scroll', displayBannerScroll);
      }
    });
  });
  // バナーのバツボタン押下で非表示にするイベント
  addEventListenerToElement(cpBannerCloseElement, "click", function () {
    modifyStyle(cpBannerElement, 'display', 'none');
    // イベントリスナーの削除
    window.removeEventListener('scroll', displayBannerScroll);
  });

  // ヘッダーの高さを取得
  var headerBannerHeight = getHeaderHeight();

  // ヘッダー吸着させる
  modifyStyle(cpBannerElement, 'height', headerBannerHeight + 'px');
  modifyStyle(cpBannerElement, 'top', '0');

  //  スクロールイベントに関数をバインド
  window.addEventListener('scroll', displayBannerScroll);
}

/**
 * キャンペーンバナーとモーダルの初期化処理
 */
function initCpBannerAndModal() {
  var cartClispList, campaign_json, bannerHtml, cpModalHtml, targetElement, vieLogHook, clickLogHook;
  return regeneratorRuntime.async(function initCpBannerAndModal$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        context$1$0.next = 2;
        return regeneratorRuntime.awrap(getCartClispList());

      case 2:
        cartClispList = context$1$0.sent;

        if (!(cartClispList.data.length >= 1)) {
          context$1$0.next = 5;
          break;
        }

        return context$1$0.abrupt('return');

      case 5:
        context$1$0.next = 7;
        return regeneratorRuntime.awrap(getCampaignJson());

      case 7:
        campaign_json = context$1$0.sent;

        // CP訴求期間中のとき、バナーを表示する
        if (campaign_json.campaign) {
          bannerHtml = null;

          if (abPattern === 'H') {
            // CPバナーと帯を組み合わせたhtmlを生成
            bannerHtml = htmlGenerators.wrapperBanner(htmlGenerators.shiryouSeikyuHeaderBanner(), htmlGenerators.obiCp(campaign_json));
          }

          // モーダルを生成
          cpModalHtml = htmlGenerators.cpModal(campaign_json);
          targetElement = document.querySelector('.js-showPanelTrigger');

          appendHtmlToTarget(targetElement, bannerHtml, cpModalHtml);

          // 入れたhtmlに対してイベントを追加する
          addEventListeners();

          // ログ処理の追加
          vieLogHook = document.querySelectorAll('.js-includeViewLog');

          (0, _jsAssetsComponent_sendScrollLog.initScrollLog)(window.s, vieLogHook, 'inviewLog');
          clickLogHook = document.querySelectorAll('.js-includeClickLog');

          (0, _jsAssetsComponent_sendClickLog.initClickLog)(clickLogHook, 'clickLog');
        }

      case 9:
      case 'end':
        return context$1$0.stop();
    }
  }, null, this);
}

var displayWidth = window.innerWidth;

window.addEventListener('resize', function () {
  if (displayWidth === window.innerWidth) return;
  var toggleElement = document.querySelector('.js-includeToggleDisplay');
  if (window.innerWidth < 768 && toggleElement.style.display === 'flex') {
    modifyStyle(toggleElement, 'display', 'block');
  } else if (window.innerWidth >= 768 && toggleElement.style.display === 'block') {
    modifyStyle(toggleElement, 'display', 'flex');
  }
});

/**
 * ABパターンを判別するグローバル変数
 */
var abPattern = null;

/**
 * キャンペーンバナーとモーダル処理を初期化する関数
 */
var initCampaignBannerModal = function initCampaignBannerModal(ab) {
  abPattern = ab;
  initCpBannerAndModal();
};
exports.initCampaignBannerModal = initCampaignBannerModal;

// エラーの時はCP訴求期間外扱いにする

// エラーの時は0件扱いにする

// カート情報を取得する

// カートに追加されている時は何も表示しない

// キャンペーン情報を取得する

// 画面にhtmlを入れる

},{"../../../../../js/assets/component/_sendClickLog":1,"../../../../../js/assets/component/_sendScrollLog":2}],6:[function(require,module,exports){
// マイページ
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _frontendSrcJsContents_getLoginStatus = require('../../../../../../../frontend/src/js/contents/_getLoginStatus');

var _SendAdobeAnalytics = require('../_SendAdobeAnalytics');

var setLocalStorage = function setLocalStorage(key, value, expirationDays) {
  var expirationTime = expirationDays * 24 * 60 * 60 * 1000;
  var currentTime = new Date().getTime();
  var expirationDate = new Date(currentTime + expirationTime);
  var item = {
    value: value,
    expiration: expirationDate.getTime()
  };
  localStorage.setItem(key, JSON.stringify(item));
};

var modalElements = '\n  <div class="mypageModal js-mypageModal">\n    <div class="mypageModal__wrapper js-mypageModalWrapper">\n      <div class="mypageModal__contents js-mypageModalContents">\n        <div class="mypageModal__contentsHeader">\n          <p class="mypageModal__contentsHeader__description"><span class="mypageModal__contentsHeader__descriptionBalloon  js-mypageModalContentsHeaderDescriptionBalloon">会員限定！</span>今後の進路検討に活かせる</p>\n          <p class="mypageModal__contentsHeader__title"><span class="mypageModal__contentsHeader__titleUnderline">マイページ機能</span>ができました！</p>\n        </div>\n        <div class="mypageModal__contentsBody js-mypageModalContentsBody">\n          <ul class="mypageModal__contentsBody__list">\n            <li class="mypageModal__contentsBody__listItem">\n              <div class="mypageModal__contentsBody__listItemImageWrap"><img class="mypageModal__contentsBody__listItemImage" src="/rnet/include/s/commonPage/STop01/mypageModal_01.png" alt=""></div>\n              <p class="mypageModal__contentsBody__listItemText">気になる学校を検索して<span class="mypageModal__contentsBody__listItemTextBold">お気に入り登録</span>ができます！</p>\n            </li>\n            <li class="mypageModal__contentsBody__listItem">\n              <div class="mypageModal__contentsBody__listItemImageWrap"><img class="mypageModal__contentsBody__listItemImage" src="/rnet/include/s/commonPage/STop01/mypageModal_02.png" alt=""></div>\n              <p class="mypageModal__contentsBody__listItemText">学部や順位を追加して、<span class="mypageModal__contentsBody__listItemTextBold">自分の志望校を設定</span>できます！</p>\n            </li>\n            <li class="mypageModal__contentsBody__listItem">\n              <div class="mypageModal__contentsBody__listItemImageWrap"><img class="mypageModal__contentsBody__listItemImage" src="/rnet/include/s/commonPage/STop01/mypageModal_03.png" alt=""></div>\n              <p class="mypageModal__contentsBody__listItemText">登録した情報から、<span class="mypageModal__contentsBody__listItemTextBold">おすすめの学校を紹介！</span>進路検討に活かそう！</p>\n            </li>\n          </ul>\n        </div>\n        <div class="mypageModal__contentsFooter">\n          <div class="mypageModal__contentsFooter__buttonWrap">\n            <p class="mypageModal__contentsFooter__balloon js-mypageModalContentsFooterBalloon">今すぐ新機能を使ってみよう！</p>\n            <button class="mypageModal__contentsFooter__buttonAnchor js-mypageModalContentsFooterButtonAnchor">ログイン・会員登録</button>\n          </div>\n        </div>\n      </div>\n      <p class="mypageModal__closeButton js-mypageModalCloseButton">閉じる</p>\n    </div>\n  </div>\n';

var mypageModal = function mypageModal() {

  var isShowMypageModal = localStorage.getItem('fe-1950-mypageModal');
  // モーダルが1度表示済み＆ローカルストレージの有効期限内の場合だったら表示させない
  if (isShowMypageModal) {
    var storageData = JSON.parse(isShowMypageModal);
    var expirationTime = storageData.expiration;
    var currentTime = new Date().getTime();
    if (currentTime <= expirationTime) return;
  }
  // モーダルをマウントする要素
  var mypageModalView = document.querySelector('.js-mypageModalView');
  if (!mypageModalView) return;

  // モーダルdom準備
  mypageModalView.insertAdjacentHTML('afterbegin', modalElements);
  (0, _frontendSrcJsContents_getLoginStatus.getLoginStatus)(false, function (loginStatus) {
    // ログイン状態の場合、モーダル内の要素を変更する
    if (loginStatus === 0) {
      var mypageModalContentsHeaderDescriptionBalloon = mypageModalView.querySelector('.js-mypageModalContentsHeaderDescriptionBalloon');
      var mypageModalContentsFooterBalloon = mypageModalView.querySelector('.js-mypageModalContentsFooterBalloon');
      var _mypageModalContentsFooterButtonAnchor = mypageModalView.querySelector('.js-mypageModalContentsFooterButtonAnchor');
      mypageModalContentsHeaderDescriptionBalloon.style.display = 'none';
      mypageModalContentsFooterBalloon.style.display = 'none';
      _mypageModalContentsFooterButtonAnchor.innerText = 'お気に入りの学校を登録する';
    }

    if (trace_p === 'Slist_f_All') {
      var modalElement = document.querySelector('.js-includeCpModal');
      if (modalElement) {
        // インラインスタイルの display プロパティを取得
        var displayStyle = modalElement.style.display;
        // display プロパティが flex かどうかをチェック
        if (displayStyle === 'flex') return;
      }
    }

    if (trace_p === 'SShisyo' || trace_p === 'SBuncon') {
      var modalElement = document.querySelector('.js-sectionCpModal');
      if (modalElement) {
        var displayStyle = modalElement.classList.contains('is-show');
        if (displayStyle) return;
      }
    }

    var specialModalElement = document.getElementById('js-gakkoSpecialBannerModal');
    if (specialModalElement && specialModalElement.classList.contains('is-showModal')) return;

    // モーダルを表示
    var mypageModal = mypageModalView.querySelector('.js-mypageModal');
    mypageModal.classList.add('is-show');
    // モーダル表示時のログ送信
    var logValue = loginStatus === 0 ? 'SMemberModal_member_' + trace_p : 'SMemberModal_nonMember_' + trace_p;
    (0, _SendAdobeAnalytics.SendCustomLinkLog)(mypageModal, logValue);

    // モーダルを表示したらローカルストレージに判定用の値を追加
    setLocalStorage('fe-1950-mypageModal', true, 30);

    var closeModal = function closeModal() {
      mypageModal.classList.remove('is-show');
      // モーダル閉じた時のログ送信
      var logValue = loginStatus === 0 ? 'SMemberModal_member_close_' + trace_p : 'SMemberModal_nonMember_close_' + trace_p;
      (0, _SendAdobeAnalytics.SendCustomLinkLog)(mypageModal, logValue);
    };

    // 閉じるボタン押下時
    var mypageModalCloseButton = mypageModalView.querySelector('.js-mypageModalCloseButton');
    mypageModalCloseButton.addEventListener('click', function (event) {
      event.stopPropagation(); // イベントの伝搬を停止
      closeModal();
    });

    // モーダルの外枠押下で、モーダルを閉じる
    mypageModal.addEventListener('click', closeModal);

    // モーダル本体押下でモーダルが閉じるのを止める
    var mypageModalContents = mypageModalView.querySelector('.js-mypageModalContents');
    mypageModalContents.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    // ログイン or お気に入りボタン押下時
    var mypageModalContentsFooterButtonAnchor = mypageModalView.querySelector('.js-mypageModalContentsFooterButtonAnchor');
    mypageModalContentsFooterButtonAnchor.addEventListener('click', function (event) {
      event.preventDefault();
      // ボタン時のログ送信
      var logValue = loginStatus === 0 ? 'SMemberModal_member_favoriteRegister_' + trace_p : 'SMemberModal_nonMember_login_' + trace_p;
      var link = loginStatus === 0 ? '/smp2/quipMember/favorite/top/' : '/smp2/quipMember/auth/organicSignIn/';
      (0, _SendAdobeAnalytics.SendCustomLinkLog)(mypageModal, logValue);
      // ログ送信より先に画面遷移しないようsetTimeoutで遅らせる
      setTimeout(function () {
        window.location.href = link;
      }, 300);
    });

    // モーダルが画面に収まらない時にコンテンツをスクロースさせるための処理
    var mypageModalWrapper = document.querySelector('.js-mypageModalWrapper');
    var mypageModalContentsBody = document.querySelector('.js-mypageModalContentsBody');

    // 要素がなければリターン
    if (!mypageModalWrapper || !mypageModalContentsBody) return;

    var wrapperHeight = mypageModalWrapper.offsetHeight + 40;
    var contentsBodyHeight = mypageModalContentsBody.offsetHeight;
    var resizeTimer = undefined;

    var adjustModalHeight = function adjustModalHeight() {
      if (window.innerHeight < wrapperHeight) {
        var setContentsBodyHeight = contentsBodyHeight + (window.innerHeight - wrapperHeight);
        mypageModalContentsBody.style.height = setContentsBodyHeight + 'px';
      } else {
        mypageModalContentsBody.style.height = 'auto';
      }
    };

    adjustModalHeight();

    // リサイズ時にも高さを再調整
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        adjustModalHeight();
      }, 100);
    });
  });
};
exports.mypageModal = mypageModal;

},{"../../../../../../../frontend/src/js/contents/_getLoginStatus":7,"../_SendAdobeAnalytics":4}],7:[function(require,module,exports){
/**
 * @description ユーザーのログイン状態を取得するAjax
 * @param {boolean} isPc trueならpc, falseならspを表す
 * @return {boolean} trueならログイン, spなら未ログイン
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getLoginStatus = function getLoginStatus(isPc, callBack) {
  var xhr = new XMLHttpRequest();
  var type = isPc ? 'net2' : 'smp2';
  var getLoginStatusInterval = window.setInterval(function () {
    // 非同期処理直列化 ajaxFlagはグローバル変数で、非同期処理実行判定フラグとして用いている
    if (!window.ajaxFlag) return;
    window.ajaxFlag = false;
    xhr.open('GET', '/' + type + '/quipMember/auth/signInStatusJson', true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          // リクエスト正常終了時
          callBack(JSON.parse(xhr.response).resultCode);
        } else {
          // リクエストエラー時
          callBack(1);
        }
      }
    };
    xhr.onloadend = function () {
      window.ajaxFlag = true;
    };
    // 非同期処理直列化 ajax実行完了したら繰り返し処理を解除する
    window.clearInterval(getLoginStatusInterval);
    xhr.send();
  }, 500);
};
exports.getLoginStatus = getLoginStatus;

},{}]},{},[3]);
